import { motion } from "framer-motion";
import { WaitlistForm } from "./WaitlistForm";

const AppleIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M16.365 1.43c0 1.14-.42 2.2-1.11 2.98-.75.86-1.98 1.52-3.02 1.44-.13-1.1.42-2.26 1.08-3 .74-.84 2.02-1.46 3.05-1.42zM20.5 17.05c-.55 1.27-.81 1.83-1.52 2.95-.99 1.57-2.39 3.53-4.13 3.54-1.54.02-1.94-1-4.03-.99-2.09.01-2.53 1.01-4.07.99-1.74-.02-3.06-1.78-4.05-3.35C-.13 16.9-.4 12.03 1.24 9.43c1.16-1.85 2.99-2.94 4.71-2.94 1.75 0 2.85 1 4.29 1 1.4 0 2.25-1 4.28-1 1.53 0 3.15.83 4.31 2.27-3.79 2.07-3.17 7.48 1.67 8.29z" />
  </svg>
);

const PlayIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M3.5 2.1v19.8c0 .5.55.82.98.57l17.02-9.9c.43-.25.43-.89 0-1.14L4.48 1.53c-.43-.25-.98.07-.98.57z" fill="url(#g)" />
    <defs>
      <linearGradient id="g" x1="3" y1="2" x2="21" y2="22" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00E5FF" />
        <stop offset="1" stopColor="#D4FF00" />
      </linearGradient>
    </defs>
  </svg>
);

const StoreButton = ({ Icon, top, bottom, testid }) => (
  <a
    href="#join"
    data-testid={testid}
    className="group flex items-center gap-3 rounded-2xl border border-textMuted/25 bg-surface px-6 py-3.5 transition-colors duration-200 hover:border-aqua"
  >
    <Icon className="h-7 w-7 shrink-0 text-textMain transition-colors group-hover:text-aqua" />
    <span className="text-left leading-tight">
      <span className="block text-[10px] uppercase tracking-widest text-textMuted">{top}</span>
      <span className="block font-display text-lg font-700 text-textMain">{bottom}</span>
    </span>
  </a>
);

export const DownloadFooter = () => {
  return (
    <footer id="join" data-testid="footer" className="relative overflow-hidden border-t border-textMuted/15 bg-surface/40">
      <div className="mx-auto max-w-[1400px] px-6 py-28 md:px-10 md:py-40">
        <div className="grid gap-16 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <motion.h2
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              className="font-display text-[22vw] font-900 leading-[0.82] tracking-tighter text-textMain lg:text-[13vw]"
            >
              DIVE
              <br />
              <span className="text-stroke-aqua">IN.</span>
            </motion.h2>
          </div>

          <div className="flex flex-col justify-end lg:col-span-5">
            <p className="mb-3 text-xs font-600 uppercase tracking-[0.3em] text-aqua">Get early access</p>
            <p className="mb-6 max-w-sm text-lg text-textMuted">
              Be first in the pool. Drop your email and we'll send your invite the moment Aqua Fit Coach launches.
            </p>
            <WaitlistForm source="footer" testid="footer-waitlist" />

            <div className="mt-8 flex flex-wrap gap-4">
              <StoreButton Icon={AppleIcon} top="Download on the" bottom="App Store" testid="btn-app-store" />
              <StoreButton Icon={PlayIcon} top="Get it on" bottom="Google Play" testid="btn-google-play" />
            </div>
          </div>
        </div>

        <div className="mt-24 flex flex-col items-start justify-between gap-6 border-t border-textMuted/15 pt-8 md:flex-row md:items-center">
          <div className="flex items-center gap-2">
            <span className="h-2.5 w-2.5 rounded-full bg-aqua shadow-[0_0_16px_#00E5FF]" />
            <span className="font-display text-xl font-800 tracking-tight text-textMain">Aqua Fit Coach</span>
          </div>
          <p className="text-sm text-textMuted">© {new Date().getFullYear()} Aqua Fitness LLC. All rights reserved.</p>
          <div className="flex gap-6 text-sm text-textMuted">
            <a href="#manifesto" className="transition-colors hover:text-aqua">Manifesto</a>
            <a href="#features" className="transition-colors hover:text-aqua">Features</a>
            <a href="#voices" className="transition-colors hover:text-aqua">Voices</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
